var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"style-class-element",on:{"click":function($event){return _vm.setActive(_vm.item)}}},[_c('v-list-item-action',{staticClass:"my-0 mx-0 pr-2",class:{
      'style-class-element-img': true,
      'style-class-element-img-active': _vm.isActive,
    }},[_c('layer-style-preview-icon',{attrs:{"is-icon":"","layer-type":_vm.layerType,"layer-style":_vm.item}})],1),_c('v-list-item-content',{staticClass:"py-0 style-class-element-content"},[_c('v-list-item-title',{class:{
        'style-class-title': true,
        'style-class-active': _vm.isActive,
      }},[_vm._v(" "+_vm._s(_vm.getStyleClassOthersValue(_vm.item))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }